import {Component, OnDestroy, OnInit} from '@angular/core';
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {IDocument} from "../../interfaces/document.definition";
import {BusService} from "../../services/bus.service";
import {Subject} from "rxjs/Subject";
import {DocumentService} from "../../services/document.service";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {paramsHelper} from "../../helpers/params-helper";
import {CollectionService} from "../../services/collection.service";
import {IAdsSettings} from "../../definitions";
import {isUndefined} from "util";

@Component({
  selector: 'app-advertisement',
  templateUrl: './advertisement.component.html',
  styles: []
})
export class AdvertisementComponent implements OnInit, OnDestroy {

  E_ENDPOINTS = E_ENDPOINTS;

  document: IDocument;
  documentType: string = DOCUMENT_TYPES.ADS_SETTINGS;
  documentId: string = null;
  tabsConfig = [
    "Android",
    "iOS",
    "Множители лимитов"
  ];

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private collectionService:CollectionService,
              private busService: BusService,
              private documentService: DocumentService) {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(e => {this.document = e.document;});
    this.busService.onDocumentSaved
      .takeUntil(this.unsubscribe)
      .subscribe(e => this.loadDocument());
  }

  ngOnInit() {
    const params = paramsHelper.loader()
      .setEndpointApi()
      .setNavParams(0, 1)
      .setObjectType(this.documentType);

    this.collectionService.loadChunkAndAssertOne(params)
      .takeUntil(this.unsubscribe)
      .subscribe(document => {
        this.documentId = document._id;
        this.loadDocument();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getSettings(osName:string):IAdsSettings{
    if (osName == "limitMultipliers" && isUndefined(this.document[osName])) {
      this.document[osName] = [];
    }

    return this.document[osName];
  }

  private loadDocument():void {
    this.documentService.load(E_ENDPOINTS.API, this.documentType, this.documentId);
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/advertisement/advertisement.component.ts